<script lang="ts">
	import { serializeSchema } from '$lib/js/structured_data';

	interface Props {
		schema: Record<string, any>;
	}

	let { schema }: Props = $props();
</script>

<svelte:head>
	{@html serializeSchema(schema)}
</svelte:head>
